import { ThirdPartyEvaluationFormItem } from './thirdparty-evaluation-form-item';

export class ThirdPartyEvaluationFormItemAnswer {
    id: number | ThirdPartyEvaluationFormItem = 0;
    description: string = '';
    isTrue?: boolean;
    isCommentRequired: boolean = true;

    constructor() {
    }
}
